import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import LoginPage from "../Components/Login/LoginPage";
import RegistrationForm from "../Components/Login/RegistrationForm";
import Unauthorized from "../Auth/Unauthorized";
import RequireAuth from "../Auth/RequireAuth";
import Missing from "./Missing";
import { persister } from "../Reducers/store";
import Dashboard from "../Components/DashBoard/Dashboard";
import PaymentReport from "../Components/Roles/Beneficiary/CESSPayment/PaymentReport";
import Forgotpassword from "../Components/Login/Forgotpassword";
import CessPaymentDetails from "../Components/Roles/Beneficiary/CESSPayment/CessPaymentDetails";
import AloReportDashboard from "../Components/Roles/Employee/HO/AloReportDashboard";
import AloMappedReport from "../Components/Roles/Employee/HO/AloMappedReport";
import AloUnMappedReport from "../Components/Roles/Employee/HO/AloUnMappedReport";
import ACLReport from "../Components/Roles/Employee/HO/ACLReport";
import ACLMappedReport from "../Components/Roles/Employee/HO/ACLMappedReport";
import AloMappedMandalsReport from "../Components/Roles/Employee/HO/AloMappedMandalsReport";
import AloDrillDown from "../Components/Roles/Employee/HO/AloDrillDown";
import AloDetailsUpdate from "../Components/Roles/Employee/HO/AloDetailsUpdate";
import MandalsMapped from "../Components/Roles/Employee/HO/MandalsMapped";
import CESSPaymentScreen from "../Components/Roles/Beneficiary/CESSPayment/CESSPaymentScreen";
import EstablishmentApplication from "../Components/Roles/OpenForms/EstablishmentApplication";
import WorkerRegistrationForm from "../Components/Roles/OpenForms/WorkerRegistrationForm";
import InWardChequeIn from "../Components/Roles/Employee/HO/InWardChequeIn";
import InwardCheckerDateWiseReport from "../Components/Roles/Employee/HO/InwardCheckerDateWiseReport";
import InwardCheckerReport from "../Components/Roles/Employee/HO/InwardCheckerReport";
import ApprovalReport from "../Components/Roles/Employee/HO/ApprovalReport";
import ApprovalPrint from "../Components/Roles/Employee/HO/ApprovalPrint";
import InwardDashboard from "../Components/Roles/Employee/HO/InwardDashboard";
import InwardDaywiseDashboard from "../Components/Roles/Employee/HO/InwardDaywiseDashboard";
import ApprovalPaymentReport from "../Components/Roles/Employee/HO/ApprovalPaymentReport";
import ApprovalPaymentConfirm from "../Components/Roles/Employee/HO/ApprovalPaymentConfirm";
import WorkerRegistrationReport from "../Components/Roles/Employee/ALO/WorkerRegistrationReport";
import WorkerRegistrationReport2 from "../Components/Roles/Reports/WorkerRegistration/WorkerRegistrationReport2";
import ZclWorkerRegReport from "../Components/Roles/Reports/WorkerRegistration/ZclWorkerRegReport";
import DclWiseWorkerRegReport from "../Components/Roles/Reports/WorkerRegistration/DclWiseWorkerRegReport";
import ACLWiseWorkerRegReport from "../Components/Roles/Reports/WorkerRegistration/ACLWiseWorkerRegReport";
import AloWiseWorkerRegReport from "../Components/Roles/Reports/WorkerRegistration/AloWiseWorkerRegReport";
import MandalWiseRegReport from "../Components/Roles/Reports/WorkerRegistration/MandalWiseRegReport";

import ALOEstablishmentRegReport from "../Components/Roles/Reports/EstablishmentRegistration/ALOEstablishmentRegReport";

import MandalEstablishmentRegReport from "../Components/Roles/Reports/EstablishmentRegistration/MandalEstablishmentRegReport";
import ZclEstablishmentRegReport from "../Components/Roles/Reports/EstablishmentRegistration/ZclEstablishmentRegReport";
import DclEstablishmentRegReport from "../Components/Roles/Reports/EstablishmentRegistration/DclEstablishmentRegReport";
import AclEstablishmentReport from "../Components/Roles/Reports/EstablishmentRegistration/AclEstablishmentReport";
import EstablishmentRegReport from "../Components/Roles/Reports/EstablishmentRegistration/EstablishmentRegReport";
import Loader from "../Components/CommonUtils/Loader";
import Refund_Cancellation from "../Components/CommonUtils/Refund_Cancellation";

import EstablishmentReport from "../Components/Roles/Reports/EstablishmentRegistration/EstablishmentReport";
import PaymentResponse from "../Components/Login/PaymentResponse";
import SbiPayment from "../Components/Login/SbiPayment";

import DashBoardMain from "../Components/DashBoard/DashBoardMain";
import PayReport from "../Components/Roles/Beneficiary/CESSPayment/PayReport";
import Index2 from "../Components/Roles/OpenForms/Index";
import StaticPaymentPage from "../Components/Login/StaticPaymentPage";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import CessPayment from "../Components/Login/CessPayment";
import CessPaymentReport from "../Components/Roles/Beneficiary/CESSPayment/CessPaymentReport";
import IdCard from "../Components/Roles/OpenForms/IdCard";
import NewReg from "../Components/Login/NewReg";
import EmpanelmentForm from "../Components/Roles/OpenForms/EmpanelmentForm";
import CessSbiPayment from "../Components/Login/CessSbiPayment";
import EstablishmentSbiPayment from "../Components/Login/EstablishmentSbiPayment";
import TradeSbiPayment from "../Components/Login/TradeSbiPayment";
import SbiPaymentRenewal from "../Components/Login/SbiPaymentRenewal";
import SbiPaymentMigrant from "../Components/Login/SbiPaymentMigrant";


const queryClient = new QueryClient();
const ROLES = {
  'emp': 8,
  'mobile': 1,
  //'user':1,
  'citizen': 7,
  'builder': 6,
}

const RoutesComponent = () => (

  <PersistGate loading={null} persistor={persister}>
    <QueryClientProvider client={queryClient}>
      <Router>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          {/* public routes */}
          <Route path="/EstablishmentApplication" element={<EstablishmentApplication></EstablishmentApplication>}></Route>
          <Route path="/WorkerRegistrationForm" element={<WorkerRegistrationForm></WorkerRegistrationForm>}></Route>
          <Route path="/cessPaymentForm" element={<CESSPaymentScreen></CESSPaymentScreen>}></Route>
          <Route path="/CESSPaymentScreen" element={<CessPaymentReport />}></Route>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/paymentresponse" element={<PaymentResponse />} />
          <Route path="/sbipayment" element={<SbiPayment />} />
          {/* <Route path="/SbiPaymentMigrant" element={<SbiPaymentMigrant />} /> */}


          <Route path="/cesspayment" element={<CessSbiPayment />} />

          <Route path="/PaymentPage" element={<StaticPaymentPage />} />
          <Route path="/CessPayment" element={<CessPayment />} />

          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/RegistrationForm" element={<RegistrationForm></RegistrationForm>}></Route>
          <Route path="/Forgotpassword" element={<Forgotpassword />}></Route>
          <Route path="/DashBoardMain" element={<DashBoardMain />} />
          <Route path="/PayReport" element={<PayReport />} />
          <Route path="/IdCard" element={<IdCard />} />
          <Route path="/NewReg" element={<NewReg />} />
          <Route path="/RefundandCancellationPolicy" element={<Refund_Cancellation />} />



          {/* <Route path="/AloDetailsUpdate" element={<AloDetailsUpdate/>}></Route>
        <Route path="/AloDrillDown" element={<AloDrillDown/>}></Route>
        <Route path="/MandalsMapped" element={<MandalsMapped/>}></Route> */}

          { /* we want to protect these routes */}
          <Route element={<RequireAuth allowedRoles={[ROLES.emp]} />}>
            <Route path="/Dashboard" element={<Dashboard />} />





            {/*  ACL & Alo */}
            <Route path="/AloReportDashboard" element={<AloReportDashboard />} />
            <Route path="/AloMappedReport" element={<AloMappedReport />} />
            <Route path="/AloUnMappedReport" element={<AloUnMappedReport />} />
            <Route path="/ACLReport" element={<ACLReport />} />
            <Route path="/ACLMappedReport" element={<ACLMappedReport />} />
            <Route path="/AloMappedMandalsReport" element={<AloMappedMandalsReport />} />
            <Route path="/AloDrillDown" element={<AloDrillDown />}></Route>
            <Route path="/AloDetailsUpdate" element={<AloDetailsUpdate />}></Route>
            <Route path="/MandalsMapped" element={<MandalsMapped />}></Route>
            <Route path="/InWardChequeIn" element={<InWardChequeIn />}></Route>
            <Route path="/InwardCheckerDateWiseReport" element={<InwardCheckerDateWiseReport ></InwardCheckerDateWiseReport>}></Route>
            <Route path="/InwardCheckerReport" element={<InwardCheckerReport></InwardCheckerReport>}></Route>

            <Route path="/ApprovalPrint" element={<ApprovalPrint ></ApprovalPrint>}></Route>
            <Route path="/InwardDashboard" element={<InwardDashboard ></InwardDashboard>}></Route>
            <Route path="/ApprovalReport" element={<ApprovalReport></ApprovalReport>}></Route>
            <Route path="/ApprovalPaymentReport" element={<ApprovalPaymentReport ></ApprovalPaymentReport>}></Route>

            <Route path="/ApprovalPaymentConfirm" element={<ApprovalPaymentConfirm ></ApprovalPaymentConfirm>}></Route>
            <Route path="/InwardDaywiseDashboard" element={<InwardDaywiseDashboard ></InwardDaywiseDashboard>}></Route>
          </Route>
          <Route element={<RequireAuth allowedRoles={[ROLES.mobile]} />}>
            <Route path="/PaymentReport" element={<PaymentReport />} />
            <Route path="/CessPaymentDetails" element={<CessPaymentDetails></CessPaymentDetails>}></Route>
            <Route path="/WorkerRegistrationForm" element={<WorkerRegistrationForm></WorkerRegistrationForm>}></Route>

            {/* <Route path="/AloDetailsUpdate" element={<AloDetailsUpdate/>}></Route>
        <Route path="/AloDrillDown" element={<AloDrillDown/>}></Route>
        <Route path="/MandalsMapped" element={<MandalsMapped/>}></Route> */}
          </Route>
          <Route element={<RequireAuth allowedRoles={[ROLES.builder]} />}>


          </Route>
          <Route element={<RequireAuth allowedRoles={[ROLES.citizen]} />}>


          </Route>

          <Route path="/index2" element={<Index2></Index2>}></Route>
          <Route path="/WorkerRegistrationReport2" element={<WorkerRegistrationReport2></WorkerRegistrationReport2>}></Route>
          <Route path="/WorkerRegistrationReport" element={<WorkerRegistrationReport></WorkerRegistrationReport>}></Route>
          <Route path="/ZclWorkerRegReport" element={<ZclWorkerRegReport></ZclWorkerRegReport>}></Route>
          <Route path="/DclWiseWorkerRegReport" element={<DclWiseWorkerRegReport></DclWiseWorkerRegReport>}></Route>
          <Route path="/ACLWiseWorkerRegReport" element={<ACLWiseWorkerRegReport></ACLWiseWorkerRegReport>}></Route>
          <Route path="/AloWiseWorkerRegReport" element={<AloWiseWorkerRegReport></AloWiseWorkerRegReport>}></Route>
          <Route path="/MandalWiseRegReport" element={<MandalWiseRegReport></MandalWiseRegReport>}></Route>
          <Route path="/EstablishmentRegReport" element={<EstablishmentRegReport></EstablishmentRegReport>}></Route>
          <Route path="/ALOEstablishmentRegReport" element={<ALOEstablishmentRegReport></ALOEstablishmentRegReport>}></Route>
          <Route path="/AclEstablishmentReport" element={<AclEstablishmentReport></AclEstablishmentReport>}></Route>
          <Route path="/MandalEstablishmentRegReport" element={<MandalEstablishmentRegReport></MandalEstablishmentRegReport>}></Route>
          <Route path="/ZclEstablishmentRegReport" element={<ZclEstablishmentRegReport></ZclEstablishmentRegReport>}></Route>
          <Route path="/DclEstablishmentRegReport" element={<DclEstablishmentRegReport></DclEstablishmentRegReport>}></Route>
          <Route path="/EstablishmentReport" element={<EstablishmentReport></EstablishmentReport>}></Route>
          <Route path="/empanelmentform" element={<EmpanelmentForm></EmpanelmentForm>}></Route>
          <Route path="/EstablishmentSbiPayment" element={<EstablishmentSbiPayment></EstablishmentSbiPayment>}></Route>
          <Route path="/TradeSbiPayment" element={<TradeSbiPayment></TradeSbiPayment>}></Route>

          <Route path="/EstablishmentSbiPayment" element={<EstablishmentSbiPayment></EstablishmentSbiPayment>}></Route>
          <Route path="/TradeSbiPayment" element={<TradeSbiPayment></TradeSbiPayment>}></Route>
          <Route path="/SbiPaymentRenewal" element={<SbiPaymentRenewal />} />
          <Route path="/SbiPaymentMigrant" element={<SbiPaymentMigrant />} />


          <Route path="*" element={<Missing />} />
        </Routes>
        <Loader />

      </Router>
    </QueryClientProvider>
  </PersistGate>
);
export default RoutesComponent;
